import type { GraphQLFormattedError } from "graphql";
import { JoinProjectErrorCode } from "graphql/generated";
import type { JoinProjectMutation } from "graphql/generated";
import type { NotificationStore } from "stores/notificationStore";

// Why `JOIN_PROJECT` failed, as the arguments of `showErrorToaster`.
const getJoinProjectErrorToaster = (
  errors: readonly GraphQLFormattedError[],
): [message: string, duration?: number] => {
  switch (errors[0]?.extensions?.code) {
    case JoinProjectErrorCode.InviteNotFound:
      return [
        "We couldn't find a pending invite for this link on your account. If it was sent to a different email, try logging in with that email instead.",
        8000,
      ];
    case JoinProjectErrorCode.InviteExpired:
      return [
        "This invite has expired. Ask the project owner to send a new one.",
      ];
    case JoinProjectErrorCode.InviteDeclined:
      return [
        "This invite was already declined. Ask the project owner to send a new one.",
      ];
    default:
      return ["There was a problem accepting the invite. Please try again."];
  }
};

// Show a toast for the result of `JOIN_PROJECT` and return the id of the
// joined project. The notification center and the `/joinProject` link both
// accept invites. Each caller gives its own store, so tests can inject one.
export const showJoinProjectResult = (
  {
    data,
    errors,
  }: {
    data?: JoinProjectMutation | null;
    errors?: readonly GraphQLFormattedError[];
  },
  successMessage: string,
  notificationStore: Pick<
    NotificationStore,
    "showSuccessToaster" | "showErrorToaster"
  >,
): string | undefined => {
  if (data) {
    notificationStore.showSuccessToaster(successMessage);
    return data.joinProject;
  }
  if (errors) {
    notificationStore.showErrorToaster(...getJoinProjectErrorToaster(errors));
  }
  return undefined;
};
